<template>
  <div>
    <el-card class="card classifyTag">
      <div slot="header" class="classifyTag__header">
        <strong class="classifyTag__title">关联分类</strong>
        <button
          type="button"
          class="classifyTag__addBtn"
          @click="dialogVisible = true"
        >
          <i class="el-icon-plus" aria-hidden="true" />
          添加分类
        </button>
      </div>
      <div class="classifyTag__body">
        <p class="classifyTag__hint">
          已关联分类<span class="classifyTag__hintMuted">（选填）</span>
        </p>
        <div class="classifyTag__tags">
          <el-tag
            :key="index"
            v-for="(tag, index) in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(index)"
            class="classifyTag__tag"
          >
            {{ tag }}
          </el-tag>
          <span v-if="!dynamicTags.length" class="classifyTag__empty">暂未关联分类</span>
        </div>
      </div>
    </el-card>
    <el-dialog
      title="关联分类"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @before-close="submitData"
    >
      <div>
        <el-card class="card">
          <div slot="header">
            <strong style="font-size: 14px">已关联</strong>
          </div>
          <div>
            <el-tag
              :key="index"
              v-for="(tag, index) in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(index)"
              style="margin-right: 10px"
            >
              {{ tag }}
            </el-tag>
          </div>
        </el-card>
        <el-card class="card">
          <div slot="header">
            <strong style="font-size: 14px">可关联</strong>
          </div>
          <div>
            <div style="margin-bottom: 20px">
              <el-input
                v-model="searchClassify"
                placeholder="搜索分类"
                style="width: 200px"
                size="mini"
                @keyup.enter.native="searchClassifyFun"
                @input="searchClassifyFun"
              ></el-input>
            </div>

            <el-checkbox-group
              v-model="dynamicTags"
              v-if="allClassifyList.length !== 0"
            >
              <div
                v-for="(item, index) in allClassifyList"
                :key="index"
                class="classifyLabelContainer"
              >
                <el-checkbox :label="item">
                  <el-tooltip
                    effect="dark"
                    :content="item"
                    placement="top-start"
                    :disabled="!disAble.includes(item)"
                  >
                    <div
                      class="classifyLabel"
                      @mouseenter="visibilityChange($event, item)"
                    >
                      {{ item }}
                    </div>
                  </el-tooltip>
                </el-checkbox>
              </div>
            </el-checkbox-group>
            <el-empty description="结果为空" v-else :image-size="80"></el-empty>
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="submitData">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitData"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getAllCategory } from '../api/comment'
export default {
  name: 'classifyTag',
  props: {
    dynamicTagsList: Array | String,
    type: Number
  },
  data() {
    return {
      dynamicTags: this.dynamicTagsList,
      dialogVisible: false,
      searchClassify: '',
      searchTimer: null,
      allClassifyList: [],
      disAble: []
    }
  },
  created() {
    this.getCategoryInfo()
  },
  methods: {
    visibilityChange(event, key) {
      const ev = event.target
      const ev_weight = ev.scrollWidth // 文本的实际宽度   scrollWidth：对象的实际内容的宽度，不包边线宽度，会随对象中内容超过可视区后而变大。
      // const content_weight = this.$refs.tlp.$el.parentNode.clientWidth; // 文本容器宽度(父节点)
      if (ev_weight > 130) {
        // 实际宽度 > 可视宽度  文字溢出
        if (!this.disAble.includes(key)) {
          this.disAble.push(key)
        }
      }
    },
    handleClose(index) {
      this.dynamicTags.splice(index, 1)
    },
    //获取所有的分类信息
    getCategoryInfo(name = '') {
      getAllCategory(name, this.type).then((res) => {
        let tagMap = {}
        let arr = []
        if (res.success) {
          res.data.forEach((element) => {
            arr.push(element.name)
            tagMap[element.name] = element.id
          })
          if (JSON.stringify(this.tagMap) === '{}') {
            this.tagMap = tagMap
          }

          this.allClassifyList = arr
        }
      })
    },
    //搜索分类
    searchClassifyFun() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.getCategoryInfo(this.searchClassify)
      }, 200)
    },
    submitData() {
      this.dialogVisible = false
      this.$emit('update:dynamicTagsList', this.dynamicTags)
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
}

.classifyTag__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.classifyTag__title {
  font-size: 14px;
}

.classifyTag__addBtn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 28px;
  padding: 0 12px;
  border: 1px dashed #cce5ff;
  border-radius: 999px;
  background: #f0f7ff;
  font-size: 12px;
  font-weight: 500;
  color: #2563eb;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.classifyTag__addBtn:hover {
  border-color: #2563eb;
  background: rgba(37, 99, 235, 0.07);
  color: #1d4ed8;
}

.classifyTag__body {
  padding-top: 2px;
}

.classifyTag__hint {
  margin: 0 0 12px;
  font-size: 12px;
  color: #57534e;
}

.classifyTag__hintMuted {
  color: #a8a29e;
}

.classifyTag__tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.classifyTag__tag {
  margin: 0;
}

.classifyTag__empty {
  font-size: 12px;
  color: #78716c;
}

.classifyLabel {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 130px;
  /* line-height: 10px; */
}
.classifyLabelContainer {
  display: inline-block;
  height: 20px;
  margin-bottom: 20px;
}
.tagContainer {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.tagContainer::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

::v-deep .el-input-group__append,
.el-input-group__prepend {
  background-color: #46a0fc;
  color: #ffffff;
  border: 1px solid #46a0fc;
}
::v-deep .el-form-item--mini > .el-form-item__label {
  font-size: 12px;
}
::v-deep .el-dialog__body {
  padding: 10px 20px;
}
::v-deep .el-tag {
  cursor: pointer;
}
::v-deep .el-checkbox__input {
  margin-top: -10px;
}
</style>
